export default __webpack_public_path__ + "static/media/avatar-2.65f48ef2.jpg";